export default {"src":"/_next/static/media/logo-short.18ca02a8.svg","height":38,"width":61,"blurWidth":0,"blurHeight":0};